<template>
  <div class="py-4 container-fluid">

      <!-- Header Section -->
      <header class="card border-0 shadow-sm px-3 px-md-4 py-2 mb-4 rounded-3">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
          <div class="d-flex align-items-center gap-3">
            <div class="icon-box bg-primary text-white fw-bold rounded-3 d-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
              SC
            </div>
            <div>
              <h1 class="h6 fw-bold mb-0 text-dark tracking-tight">SMARTCAT DASHBOARD</h1>
              <small class="text-muted">
                <i class="fa-regular fa-calendar me-1"></i> Last Updated: 
                <span class="fw-semibold text-dark">{{ lastUpdate }}</span>
              </small>
            </div>
          </div>
          <div class="d-flex align-items-center gap-2">              
              <button
                type="button"
                class="btn btn-info text-white d-flex align-items-center justify-content-center fw-semibold"
                style="height: 30px; padding: 0 14px; line-height: 30px; margin: 0;"
                @click="openGenerateModal"
              >
                <i class="fa-solid fa-rotate me-1"></i> Generate
              </button>
            </div>
        </div>
      </header>

      <!-- KPI Summary Cards -->
      <!-- <section class="row g-3 mb-4">
        <div class="col-12 col-sm-6 col-xl-3">
          <div class="card border-0 shadow-sm p-3 h-100 rounded-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="text-uppercase text-muted fw-semibold" style="font-size: 0.7rem; letter-spacing: 0.05em;">Total Stock Value</span>
              <span class="icon-box bg-primary-subtle text-primary d-flex align-items-center justify-content-center" style="width: 30px; height: 30px; border-radius: 7px;">
                <i class="fa-solid fa-dollar-sign text-xs"></i>
              </span>
            </div>
            <h2 class="h4 fw-bold mb-3 text-dark">$58,250,000</h2>
            <div class="border-top pt-2 d-flex justify-content-between text-muted" style="font-size: 0.75rem;">
              <span>Spare parts: <b class="text-dark">$13.25M</b></span>
              <span>Material: <b class="text-dark">$45.00M</b></span>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-xl-3">
          <div class="card border-0 shadow-sm p-3 h-100 rounded-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="text-uppercase text-muted fw-semibold" style="font-size: 0.7rem; letter-spacing: 0.05em;">Stock Health</span>
              <span class="icon-box bg-success-subtle text-success d-flex align-items-center justify-content-center" style="width: 30px; height: 30px; border-radius: 7px;">
                <i class="fa-solid fa-chart-pie text-xs"></i>
              </span>
            </div>
            <div class="progress mb-3 bg-light" style="height: 8px; border-radius: 9999px;">
              <div class="progress-bar bg-success" style="width: 72%" title="Safe 72%"></div>
              <div class="progress-bar bg-warning" style="width: 18%" title="Low 18%"></div>
              <div class="progress-bar bg-danger" style="width: 10%" title="Out 10%"></div>
            </div>
            <div class="d-flex justify-content-between text-muted fw-medium" style="font-size: 0.75rem;">
              <span class="text-success">Safe: 72%</span>
              <span class="text-warning">Low: 18%</span>
              <span class="text-danger">Empty: 10%</span>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-xl-3">
          <div class="card border-0 shadow-sm p-3 h-100 rounded-3">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-uppercase text-muted fw-semibold" style="font-size: 0.7rem; letter-spacing: 0.05em;">Total Item ZSPR</span>
              <span class="icon-box bg-light text-secondary d-flex align-items-center justify-content-center" style="width: 30px; height: 30px; border-radius: 7px;">
                <i class="fa-solid fa-gears text-xs"></i>
              </span>
            </div>
            <div class="d-flex align-items-baseline justify-content-between mt-1">
              <h2 class="h4 fw-bold mb-0 text-dark">85 <small class="fs-6 text-muted fw-normal">Item</small></h2>
              <span class="badge bg-danger-subtle text-danger">35 Out Stock</span>
            </div>
            <div class="text-muted mt-2" style="font-size: 0.75rem;">10 Safe | 40 Low Stock</div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-xl-3">
          <div class="card border-0 shadow-sm p-3 h-100 rounded-3">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-uppercase text-muted fw-semibold" style="font-size: 0.7rem; letter-spacing: 0.05em;">Total Item ZRAW+ZSUB</span>
              <span class="icon-box bg-light text-secondary d-flex align-items-center justify-content-center" style="width: 30px; height: 30px; border-radius: 7px;">
                <i class="fa-solid fa-boxes-packing text-xs"></i>
              </span>
            </div>
            <div class="d-flex align-items-baseline justify-content-between mt-1">
              <h2 class="h4 fw-bold mb-0 text-dark">11 <small class="fs-6 text-muted fw-normal">Item</small></h2>
              <span class="badge bg-danger-subtle text-danger">5 Out Stock</span>
            </div>
            <div class="text-muted mt-2" style="font-size: 0.75rem;">2 Safe | 4 Low Stock</div>
          </div>
        </div>
      </section> -->

      <!-- Main Data Row 1 -->
      <div class="row g-3 mb-4">
        <!-- Section Material Creation -->
        <div class="col-12 d-flex flex-column flex-lg-row gap-3">
          <div class="card border-0 shadow-sm p-3 rounded-3 flex-fill w-100">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h2 class="h6 fw-bold text-dark mb-0">
                <i class="fa-regular fa-file-lines text-primary me-2"></i>Material Creation &amp; Revision
              </h2>
              <span class="badge bg-light text-secondary border">A</span>
            </div>
            <DataTable
              :value="mcrTable.onLoad ? dummyRows : mcrTable.data" size="small" removable-sort
              table-style="min-width: 100%">
              <Column field="deskripsi" header="MCR Status" header-class="bg-light text-nowrap text-dark" sortable>
                <template v-if="mcrTable.onLoad" #body>
                  <Skeleton></Skeleton>
                </template>
                <template v-else #body="slotProps">
                  <span class="text-xs">{{ slotProps.data && slotProps.data.deskripsi ? slotProps.data.deskripsi : '' }}</span>
                </template>
              </Column>
              <Column field="creation" header="Creation" header-class="bg-light text-nowrap text-dark" sortable>
                <template v-if="mcrTable.onLoad" #body>
                  <Skeleton></Skeleton>
                </template>
                <template v-else #body="slotProps">
                  <span class="text-xs font-mono text-muted">{{ slotProps.data && slotProps.data.creation ? slotProps.data.creation : '-' }}</span>
                </template>
              </Column>
              <Column field="revision" header="Revision" header-class="bg-light text-nowrap text-dark" sortable>
                <template v-if="mcrTable.onLoad" #body>
                  <Skeleton></Skeleton>
                </template>
                <template v-else #body="slotProps">
                  <span class="text-xs font-mono text-muted">{{ slotProps.data && slotProps.data.revision ? slotProps.data.revision : '-' }}</span>
                </template>
              </Column>
              <template #empty>
                <div class="text-center py-5">
                  <img src="/no_data.png" alt="No Data" class="img-fluid opacity-75" />
                  <div class="text-secondary fw-semibold">
                    No Data
                  </div>
                </div>
              </template>
            </DataTable>
          </div>

          <div class="card border-0 shadow-sm p-3 rounded-3 flex-fill w-100">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h2 class="h6 fw-bold text-dark mb-0">
                <i class="fa-regular fa-clock text-primary me-2"></i>Lead Time MCR
              </h2>
              <span class="badge bg-light text-secondary border">B</span>
            </div>
            <!-- Loading -->
            <div v-if="leadTimeMcr.onLoad" class="d-flex flex-column gap-2">
              <div v-for="n in 2" :key="n" class="p-2 bg-light rounded border">
                <Skeleton height="0.85rem" width="70%" style="margin-bottom: 0.4rem;"></Skeleton>
                <Skeleton height="0.6rem" width="45%"></Skeleton>
              </div>
            </div>

            <template v-else>
              <!-- Total per type (aggregated across all months from the API response) -->
              <template v-if="leadTimeMcr.summary.totalItems > 0">
                <div class="d-flex flex-column gap-2" style="font-size: 0.75rem;">
                  <div v-for="row in leadTimeMcr.rows" :key="row.key" class="p-2 bg-light rounded border">
                    <div class="d-flex justify-content-between align-items-baseline">
                      <span class="fw-semibold text-dark">{{ row.label }}</span>
                      <b class="font-mono text-dark" :title="`≈ ${formatNumber(row.totalHours)} jam per MCR ÷ ${workHoursPerDay} jam kerja`">
                        {{ formatNumber(row.daysAverage) }}<small class="fw-normal text-muted"> days average</small>
                      </b>
                    </div>
                    <div class="d-flex justify-content-between text-muted mt-1" style="font-size: 0.7rem;">
                      <span>{{ formatNumber(row.totalItems, 0) }} item</span>
                      <span :title="`Total durasi ${row.label} masuk ke SAP (jam kerja)`">
                        {{ formatNumber(row.totalHours) }} hours
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Grand total across all types -->
                <div class="d-flex justify-content-between border-top pt-2 mt-3 text-muted" style="font-size: 0.7rem;">
                  <span>Total: <b class="text-dark font-mono">{{ formatNumber(leadTimeMcr.summary.totalItems, 0) }}</b> item</span>
                  <span><b class="text-dark font-mono">{{ formatNumber(leadTimeMcr.summary.totalHours) }}</b> hours</span>
                  <span><b class="text-dark font-mono">{{ formatNumber(leadTimeMcr.summary.totalDays) }}</b> days</span>
                </div>
              </template>
              <div v-else class="text-center text-muted mt-3 pt-2" style="font-size: 0.75rem;">
                Not Found data lead time MCR
              </div>
            </template>
          </div>
        </div>

        <!-- Section MRP Composition (C) -->
        <div class="col-12">
          <div class="card border-0 shadow-sm p-3 h-100 rounded-3">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h2 class="h6 fw-bold text-dark mb-0">
                <i class="fa-solid fa-layer-group text-primary me-2"></i>MRP Composition
              </h2>
              <span class="badge bg-light text-secondary border">C</span>
            </div>
                <!-- Matrix: rows = MRP element (ND, V1 EX, ...), columns = material type (ZM01, ...) -->
                <DataTable
                  :value="mrpComposition.onLoad ? dummyRows : mrpComposition.matrix.rows"
                  size="small" table-style="min-width: 100%">
                  <Column field="description" header="MRP ELEMENT" header-class="bg-light text-nowrap text-dark" style="width: 150px; min-width: 150px;">
                    <template v-if="mrpComposition.onLoad" #body>
                      <Skeleton></Skeleton>
                    </template>
                    <template v-else #body="slotProps">
                      <span class="fw-semibold text-dark text-xs font-mono">{{ slotProps.data && slotProps.data.label ? slotProps.data.label : '-' }}</span>
                    </template>
                  </Column>
                  <Column v-for="type in mrpCompositionColumns" :key="type.key" :header="type.label" header-class="bg-light text-nowrap text-dark" style="width: 170px; min-width: 170px;">
                    <template v-if="mrpComposition.onLoad" #body>
                      <Skeleton></Skeleton>
                    </template>
                    <template v-else #body="slotProps">
                      <span class="font-mono text-muted text-xs">{{ slotProps.data.cells && slotProps.data.cells[type.key] ? slotProps.data.cells[type.key] : '-' }}</span>
                    </template>
                  </Column>
                  <template #empty>
                    <div class="text-center py-5">
                      <img src="/no_data.png" alt="No Data" class="img-fluid opacity-75" />
                      <div class="text-secondary fw-semibold">No Data</div>
                    </div>
                  </template>
                </DataTable>
          </div>
        </div>

        <!-- Section Material Status (D) -->
        <div class="col-12">
          <div class="card border-0 shadow-sm p-3 h-100 rounded-3">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h2 class="h6 fw-bold text-dark mb-0">
                <i class="fa-solid fa-circle-check text-primary me-2"></i>Material Status
              </h2>
              <span class="badge bg-light text-secondary border">D</span>
            </div>

            <!-- Matrix: rows = STATUS (Z1, Z2, ...), columns = material type (ZFGD, ZSPR, ...) -->
            <DataTable
              :value="materialStatus.onLoad ? dummyRows : materialStatus.matrix.rows"
              size="small" table-style="min-width: 100%">
              <Column field="status" header="STATUS" header-class="bg-light text-nowrap text-dark" style="width: 150px; min-width: 150px;">
                <template v-if="materialStatus.onLoad" #body>
                  <Skeleton></Skeleton>
                </template>
                <template v-else #body="slotProps">
                  <span class="fw-semibold text-dark text-xs font-mono">{{ slotProps.data && slotProps.data.label ? slotProps.data.label : '-' }}</span>
                </template>
              </Column>
              <Column v-for="type in materialStatusColumns" :key="type.key" :header="type.label" header-class="bg-light text-nowrap text-dark" style="width: 170px; min-width: 170px;">
                <template v-if="materialStatus.onLoad" #body>
                  <Skeleton></Skeleton>
                </template>
                <template v-else #body="slotProps">
                  <span class="font-mono text-muted text-xs">{{ slotProps.data.cells && slotProps.data.cells[type.key] ? slotProps.data.cells[type.key] : '-' }}</span>
                </template>
              </Column>
              <template #empty>
                <div class="text-center text-muted" style="font-size: 0.7rem;">No Data</div>
              </template>
            </DataTable>
          </div>
        </div>

        <!-- Section Stock Monitoring hide dulu -->
        <!-- <div class="col-12 col-lg-8">
          <div class="card border-0 shadow-sm p-3 h-100 rounded-3">
            <div class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center border-bottom pb-2 mb-3 gap-1">
              <div>
                <h2 class="h6 fw-bold text-dark mb-0">
                  <i class="fa-solid fa-list-check text-primary me-2"></i>Stock Status &amp; Monitoring
                </h2>
                <small class="text-muted">Monitoring level stok berdasarkan Reorder Point (ROP)</small>
              </div>
              <span class="badge bg-primary-subtle text-primary border border-primary-subtle font-mono">Tcode: J3RFLVMOBVEDH + MM60</span>
            </div>

            <div class="mb-4">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <span class="fw-bold text-dark text-xs">1. Spare Part (Item ZSPR)</span>
                <span class="text-muted font-mono text-xs">Total: 85 Item</span>
              </div>

              <div class="d-flex flex-column gap-2" style="font-size: 0.75rem;">
                <div class="d-flex justify-content-between align-items-center p-2 border border-success-subtle bg-success-subtle" style="border-radius: 7px;">
                  <div class="d-flex align-items-center gap-2">
                    <span class="badge rounded-circle p-1 bg-success"> </span>
                    <div>
                      <div class="fw-semibold text-dark">Stock Safe</div>
                      <small class="text-muted">Stok di atas ROP</small>
                    </div>
                  </div>
                  <span class="fw-bold font-mono text-dark fs-6">10</span>
                </div>

                <div class="d-flex justify-content-between align-items-center p-2 border border-warning-subtle bg-warning-subtle" style="border-radius: 7px;">
                  <div class="d-flex align-items-center gap-2">
                    <span class="badge rounded-circle p-1 bg-warning"> </span>
                    <div>
                      <div class="fw-semibold text-dark">Low Stock</div>
                      <small class="text-muted">Stok di bawah ROP (&gt;0)</small>
                    </div>
                  </div>
                  <span class="fw-bold font-mono text-dark fs-6">40</span>
                </div>

                <div class="d-flex justify-content-between align-items-center p-2 border border-danger-subtle bg-danger-subtle" style="border-radius: 7px;">
                  <div class="d-flex align-items-center gap-2">
                    <span class="badge rounded-circle p-1 bg-danger"> </span>
                    <div>
                      <div class="fw-semibold text-dark">Out of Stock</div>
                      <small class="text-muted">Stok habis (= 0)</small>
                    </div>
                  </div>
                  <span class="fw-bold font-mono text-danger fs-6">35</span>
                </div>
              </div>
            </div>

            <div>
              <div class="d-flex justify-content-between align-items-center mb-2">
                <span class="fw-bold text-dark text-xs">2. Material (Item ZRAW + ZSUB)</span>
                <span class="text-muted font-mono text-xs">Total: 11 Item</span>
              </div>

              <div class="d-flex flex-column gap-2" style="font-size: 0.75rem;">
                <div class="d-flex justify-content-between align-items-center p-2 border border-success-subtle bg-success-subtle" style="border-radius: 7px;">
                  <div class="d-flex align-items-center gap-2">
                    <span class="badge rounded-circle p-1 bg-success"> </span>
                    <div>
                      <div class="fw-semibold text-dark">Stock Safe</div>
                      <small class="text-muted">Stok di atas ROP</small>
                    </div>
                  </div>
                  <span class="fw-bold font-mono text-dark fs-6">2</span>
                </div>

                <div class="d-flex justify-content-between align-items-center p-2 border border-warning-subtle bg-warning-subtle" style="border-radius: 7px;">
                  <div class="d-flex align-items-center gap-2">
                    <span class="badge rounded-circle p-1 bg-warning"> </span>
                    <div>
                      <div class="fw-semibold text-dark">Low Stock</div>
                      <small class="text-muted">Stok di bawah ROP (&gt;0)</small>
                    </div>
                  </div>
                  <span class="fw-bold font-mono text-dark fs-6">4</span>
                </div>

                <div class="d-flex justify-content-between align-items-center p-2 border border-danger-subtle bg-danger-subtle" style="border-radius: 7px;">
                  <div class="d-flex align-items-center gap-2">
                    <span class="badge rounded-circle p-1 bg-danger"> </span>
                    <div>
                      <div class="fw-semibold text-dark">Out of Stock</div>
                      <small class="text-muted">Stok habis (= 0)</small>
                    </div>
                  </div>
                  <span class="fw-bold font-mono text-danger fs-6">5</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <!-- Main Data Row 2 -->
      <div class="row g-3">
        <!-- Stock Category -->
        <!-- <div class="col-12 col-lg-6">
          <div class="card border-0 shadow-sm p-3 h-100 rounded-3">
            <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
              <div>
                <h2 class="h6 fw-bold text-dark mb-0">
                  <i class="fa-solid fa-layer-group text-primary me-2"></i>Stock Category (G)
                </h2>
                <small class="text-muted">Klasifikasi pergerakan material</small>
              </div>
              <span class="badge bg-light text-secondary border font-mono">J3RFLVMOBVEDH + MM60</span>
            </div>

            <div class="mb-3">
              <span class="fw-bold text-dark d-block mb-2 text-xs">1. Spare Part</span>
              <DataTable
                :value="stockCategory.sparePart.onLoad ? dummyRows : stockCategory.sparePart.data" size="small"
                removable-sort table-style="min-width: 100%">
                <Column field="kategori" header="Kategori" header-class="bg-light text-nowrap text-dark" sortable>
                  <template v-if="stockCategory.sparePart.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <span class="fw-semibold text-xs" :class="slotProps.data.kategoriClass">{{ slotProps.data && slotProps.data.kategori ? slotProps.data.kategori : '' }}</span>
                  </template>
                </Column>
                <Column field="kriteria" header="Kriteria Transaksi" header-class="bg-light text-nowrap text-dark" sortable>
                  <template v-if="stockCategory.sparePart.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <span class="text-muted text-xs">{{ slotProps.data && slotProps.data.kriteria ? slotProps.data.kriteria : '' }}</span>
                  </template>
                </Column>
                <Column field="total_item" header="Total Item" header-class="bg-light text-nowrap text-dark" sortable>
                  <template v-if="stockCategory.sparePart.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <span class="d-block text-center font-mono text-muted text-xs">{{ slotProps.data && slotProps.data.total_item ? slotProps.data.total_item : '-' }}</span>
                  </template>
                </Column>
                <Column field="value" header="Value (USD)" header-class="bg-light text-nowrap text-dark" sortable>
                  <template v-if="stockCategory.sparePart.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <span class="d-block text-end font-mono text-muted text-xs">{{ slotProps.data && slotProps.data.value ? slotProps.data.value : '-' }}</span>
                  </template>
                </Column>
                <template #empty>
                  <div class="text-center py-5">
                    <img src="/no_data.png" alt="No Data" class="img-fluid opacity-75" />
                    <div class="text-secondary fw-semibold">No Data</div>
                  </div>
                </template>
              </DataTable>
            </div>

            <div>
              <span class="fw-bold text-dark d-block mb-2 text-xs">2. Material</span>
              <DataTable
                :value="stockCategory.material.onLoad ? dummyRows : stockCategory.material.data" size="small"
                removable-sort table-style="min-width: 100%">
                <Column field="kategori" header="Kategori" header-class="bg-light text-nowrap text-dark" sortable>
                  <template v-if="stockCategory.material.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <span class="fw-semibold text-xs" :class="slotProps.data.kategoriClass">{{ slotProps.data && slotProps.data.kategori ? slotProps.data.kategori : '' }}</span>
                  </template>
                </Column>
                <Column field="kriteria" header="Kriteria Transaksi" header-class="bg-light text-nowrap text-dark" sortable>
                  <template v-if="stockCategory.material.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <span class="text-muted text-xs">{{ slotProps.data && slotProps.data.kriteria ? slotProps.data.kriteria : '' }}</span>
                  </template>
                </Column>
                <Column field="total_item" header="Total Item" header-class="bg-light text-nowrap text-dark" sortable>
                  <template v-if="stockCategory.material.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <span class="d-block text-center font-mono text-muted text-xs">{{ slotProps.data && slotProps.data.total_item ? slotProps.data.total_item : '-' }}</span>
                  </template>
                </Column>
                <Column field="value" header="Value (USD)" header-class="bg-light text-nowrap text-dark" sortable>
                  <template v-if="stockCategory.material.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <span class="d-block text-end font-mono text-muted text-xs">{{ slotProps.data && slotProps.data.value ? slotProps.data.value : '-' }}</span>
                  </template>
                </Column>
                <template #empty>
                  <div class="text-center py-5">
                    <img src="/no_data.png" alt="No Data" class="img-fluid opacity-75" />
                    <div class="text-secondary fw-semibold">No Data</div>
                  </div>
                </template>
              </DataTable>
            </div>
          </div>
        </div> -->

        <!-- Stock Movement -->
        <!-- <div class="col-12 col-lg-6">
          <div class="card border-0 shadow-sm p-3 h-100 d-flex flex-column justify-content-between rounded-3">
            <div>
              <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                <div>
                  <h2 class="h6 fw-bold text-dark mb-0">
                    <i class="fa-solid fa-arrow-right-arrow-left text-primary me-2"></i>Stock Movement (USD) (H)
                  </h2>
                  <small class="text-muted">Estimasi pergerakan bulanan</small>
                </div>
                <span class="badge bg-light text-secondary border font-mono">Tcode: MB51</span>
              </div>

              <div class="p-2 bg-light rounded-2 border text-muted mb-3 d-flex justify-content-between" style="font-size: 0.75rem;">
                <span><b>GR (Masuk):</b> MVT 105 &amp; 101</span>
                <span><b>GI (Keluar):</b> MVT 201, 202, 261, 262, Z03, Z04</span>
              </div>

              <div class="mb-4">
                <span class="fw-bold text-dark d-block mb-2" style="font-size: 0.75rem;">1. Spare Part (ZSPR)</span>
                <div class="d-flex flex-column gap-2" style="font-size: 0.75rem;">
                  <div class="d-flex align-items-center">
                    <span class="fw-semibold text-muted me-2 font-mono" style="width: 28px;">Jan</span>
                    <div class="progress flex-grow-1 bg-light" style="height: 6px; border-radius: 9999px;">
                      <div class="progress-bar bg-success" style="width: 55%"></div>
                      <div class="progress-bar bg-danger" style="width: 35%"></div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="fw-semibold text-muted me-2 font-mono" style="width: 28px;">Feb</span>
                    <div class="progress flex-grow-1 bg-light" style="height: 6px; border-radius: 9999px;">
                      <div class="progress-bar bg-success" style="width: 40%"></div>
                      <div class="progress-bar bg-danger" style="width: 60%"></div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="fw-semibold text-muted me-2 font-mono" style="width: 28px;">Mar</span>
                    <div class="progress flex-grow-1 bg-light" style="height: 6px; border-radius: 9999px;">
                      <div class="progress-bar bg-success" style="width: 50%"></div>
                      <div class="progress-bar bg-danger" style="width: 45%"></div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="fw-semibold text-muted me-2 font-mono" style="width: 28px;">Apr</span>
                    <div class="progress flex-grow-1 bg-light" style="height: 6px; border-radius: 9999px;">
                      <div class="progress-bar bg-success" style="width: 70%"></div>
                      <div class="progress-bar bg-danger" style="width: 55%"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <span class="fw-bold text-dark d-block mb-2" style="font-size: 0.75rem;">2. Material (ZRAW, ZSUP)</span>
                <div class="d-flex flex-column gap-2" style="font-size: 0.75rem;">
                  <div class="d-flex align-items-center">
                    <span class="fw-semibold text-muted me-2 font-mono" style="width: 28px;">Jan</span>
                    <div class="progress flex-grow-1 bg-light" style="height: 6px; border-radius: 9999px;">
                      <div class="progress-bar bg-success" style="width: 65%"></div>
                      <div class="progress-bar bg-danger" style="width: 25%"></div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="fw-semibold text-muted me-2 font-mono" style="width: 28px;">Feb</span>
                    <div class="progress flex-grow-1 bg-light" style="height: 6px; border-radius: 9999px;">
                      <div class="progress-bar bg-success" style="width: 45%"></div>
                      <div class="progress-bar bg-danger" style="width: 50%"></div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="fw-semibold text-muted me-2 font-mono" style="width: 28px;">Mar</span>
                    <div class="progress flex-grow-1 bg-light" style="height: 6px; border-radius: 9999px;">
                      <div class="progress-bar bg-success" style="width: 30%"></div>
                      <div class="progress-bar bg-danger" style="width: 40%"></div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="fw-semibold text-muted me-2 font-mono" style="width: 28px;">Apr</span>
                    <div class="progress flex-grow-1 bg-light" style="height: 6px; border-radius: 9999px;">
                      <div class="progress-bar bg-success" style="width: 60%"></div>
                      <div class="progress-bar bg-danger" style="width: 60%"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-end gap-3 text-muted border-top pt-3 mt-3" style="font-size: 0.75rem;">
              <span><i class="fa-solid fa-square text-success me-1"></i> Masuk (GR)</span>
              <span><i class="fa-solid fa-square text-danger me-1"></i> Keluar (GI)</span>
            </div>
          </div>
        </div> -->
      </div>

      <!-- Dialog Generate Dashboard (select year) -->
      <DialogPrime v-model:visible="generateModal.visible" modal style="width: 30rem; margin: 10px;" class="faq-modal">
        <template #header>
          <div class="d-flex align-items-center gap-3">
            <h5 class="mb-0 fw-bold text-dark">
              Generate Dashboard
            </h5>
          </div>
        </template>
        <div class="row g-4">
          <div class="col-12">
            <label for="generateYear" class="form-label fw-semibold">Year <span class="text-danger">*</span></label>
            <Calendar
              id="generateYear"
              v-model="generateModal.year"
              view="year"
              dateFormat="yy"
              :show-icon="true"
              placeholder="Select Year"
              class="w-100"
            />
          </div>
        </div>
        <template #footer>
           <div class="d-flex gap-2">
              <ButtonPrime
                type="button" label="Cancel" severity="danger" raised size="small"
                class="px-4 border-0" @click="closeGenerateModal()" />
              <ButtonPrime
                type="button" severity="contrast" raised size="small"
                :disabled="generateModal.onLoading" label="Generate" class="px-4"
                @click="generateDashboard()">
                <template v-if="generateModal.onLoading" #icon>
                  <i class="fas fa-spinner fa-spin me-2"></i>
                </template>
              </ButtonPrime>
            </div>
        </template>
      </DialogPrime>
  </div>
</template>

<script>
import dashboardService from "@/services/dashboards/dashboardService";
import Calendar from "primevue/calendar";

// lead_time_mcr arrives per month: { "1"..."12": { material_creation: {...}, material_revision: {...} } }
const LEAD_TIME_TYPES = [
  { key: "material_creation", label: "Creation" },
  { key: "material_revision", label: "Revision" },
];

// Working hours per day used by the backend to compute day_per_item:
// day_per_item = (total_duration_hours / total_item) / WORK_HOURS_PER_DAY.
// Mirrored here so the total working days (total hours / WORK_HOURS_PER_DAY)
// stay consistent with the backend calculation.
const WORK_HOURS_PER_DAY = 8;

// Canonical STATUS row order for the Material Status matrix card (D).
// Rows render in this order; unknown statuses (from entry.status or the
// fallback block_reason / plant_sp code) are appended alphabetically.
const MATERIAL_STATUS_ORDER = ["Z1", "Z2", "Z3", "Z4", "Z5", "Z6", "Z7", "Z8"];

export default {
  name: "Home",
  components: {
    Calendar,
  },
  data() {
    const categoryRows = [
      { kategori: "Fast Moving", kategoriClass: "text-success", kriteria: "GI tiap tahun (MVT 201, 202, 261, 262)", total_item: "-", value: "-" },
      { kategori: "Excess", kategoriClass: "text-primary", kriteria: "Type MRP ND & ada stock", total_item: "-", value: "-" },
      { kategori: "Slow Moving", kategoriClass: "text-warning", kriteria: "Tidak ada GI >1 s/d <5 thn", total_item: "-", value: "-" },
      { kategori: "Dead Stock", kategoriClass: "text-danger", kriteria: "Tidak ada transaksi >= 5 thn", total_item: "-", value: "-" },
    ];
    return {
      lastUpdate: "-",
      generateModal: {
        visible: false,
        year: null,
        onLoading: false,
      },
      mcrTable: {
        onLoad: true,
        data: [],
      },
      leadTimeMcr: {
        onLoad: true,
        rows: [],
        summary: { totalItems: 0, totalHours: 0, totalDays: 0 },
      },
      mrpComposition: {
        onLoad: true,
        matrix: { types: [], rows: [] },
      },
      materialStatus: {
        onLoad: true,
        matrix: { types: [], rows: [] },
      },
      stockCategory: {
        sparePart: { onLoad: true, data: [...categoryRows] },
        material: { onLoad: true, data: [...categoryRows] },
      },
      dummyRows: Array.from({ length: 5 }, () => ({})),
    };
  },
  computed: {
    workHoursPerDay() {
      return WORK_HOURS_PER_DAY;
    },
    // Matrix columns for card D: real material types once mapped, none while
    // loading or after a failed load (empty state).
    materialStatusColumns() {
      const types = this.materialStatus.matrix && this.materialStatus.matrix.types;
      return types || [];
    },
    // Matrix columns for card C: real material types once mapped, none while
    // loading or after a failed load (empty state).
    mrpCompositionColumns() {
      const types = this.mrpComposition.matrix && this.mrpComposition.matrix.types;
      return types || [];
    },
  },
  mounted() {
    // Simulasi loading supaya skeleton tampil seperti di faq.vue
    // (mcrTable & leadTimeMcr sudah dikontrol oleh loadDashboard)
    setTimeout(() => {
      this.stockCategory.sparePart.onLoad = false;
      this.stockCategory.material.onLoad = false;
    }, 800);

    this.loadDashboard();
  },
  methods: {
    openGenerateModal() {
      if (!this.generateModal.year) {
        this.generateModal.year = new Date();
      }
      this.generateModal.visible = true;
    },
    closeGenerateModal() {
      this.generateModal.visible = false;
      this.generateModal.onLoading = false;
    },
    // GET /api/dashboard/generate?year=YYYY -> generate ulang data dashboard dari SAP
    generateDashboard() {
      const year = this.generateModal.year instanceof Date ? this.generateModal.year.getFullYear() : null;
      if (!year) {
        this.$toastNotifPrime("warn", "Warning", "Please select a year!");
        return;
      }
      this.generateModal.onLoading = true;
      dashboardService.generate(year)
        .then((res) => {
          const message = (res.data && (res.data.message || res.data.data?.message)) || "Dashboard berhasil di-generate.";
          this.$toastNotifPrime("success", "Success", message);
          this.generateModal.visible = false;
          // Response generate isinya sama dengan response get, jadi langsung dipakai
          // tanpa perlu GET ulang.
          const data = res.data && res.data.data ? res.data.data : res.data;
          this.applyDashboardData(data);
        })
        .catch((error) => {
          const message = (error.response && error.response.data && (error.response.data.message || error.response.data.error)) || "Gagal generate dashboard.";
          this.$toastNotifPrime("error", "Error", message);
        })
        .finally(() => {
          this.generateModal.onLoading = false;
        });
    },
    loadDashboard(year = new Date().getFullYear()) {
      this.mcrTable.onLoad = true;
      this.leadTimeMcr.onLoad = true;
      this.mrpComposition.onLoad = true;
      this.materialStatus.onLoad = true;
      dashboardService .get({ year })
        .then((res) => {
          const data = res.data && res.data.data ? res.data.data : res.data;
          this.applyDashboardData(data);
        })
        .catch(() => {
          this.lastUpdate = "-";
          this.mcrTable.data = [];
          this.leadTimeMcr.rows = [];
          this.leadTimeMcr.summary = { totalItems: 0, totalHours: 0, totalDays: 0 };
          this.mrpComposition.matrix = { types: [], rows: [] };
          this.materialStatus.matrix = { types: [], rows: [] };
        })
        .finally(() => {
          this.mcrTable.onLoad = false;
          this.leadTimeMcr.onLoad = false;
          this.mrpComposition.onLoad = false;
          this.materialStatus.onLoad = false;
        });
    },
    // Endpoint get dan generate mengembalikan struktur data yang sama,
    // jadi keduanya memakai pemetaan ini.
    applyDashboardData(data) {
      this.mapMcrs(data && data.material_creation_revision);
      this.mapLeadTime(data && data.lead_time_mcr);
      this.mapMrpComposition(data && data.mrp_composition);
      this.mapMaterialStatus(data && data.material_status);
      this.lastUpdate = this.formatLastUpdate(data && data.last_update);
    },
    // Aggregate lead_time_mcr across all months into totals per type (creation/revision)
    mapLeadTime(leadTimeByMonth) {
      const byMonth = leadTimeByMonth && typeof leadTimeByMonth === "object" ? leadTimeByMonth : {};
      const totals = {};

      LEAD_TIME_TYPES.forEach(({ key }) => {
        totals[key] = { hours: 0, items: 0 };
      });

      Object.values(byMonth).forEach((monthData) => {
        if (!monthData) return;

        LEAD_TIME_TYPES.forEach(({ key }) => {
          const entry = monthData[key] || {};
          // total_duration_hours = total duration per MCR entering SAP (source of truth)
          totals[key].hours += Number(entry.total_duration_hours) || 0;
          totals[key].items += Number(entry.total_item) || 0;
        });
      });

      const rows = LEAD_TIME_TYPES.map(({ key, label }) => {
        const { hours, items } = totals[key];
        return {
          key,
          label,
          totalHours: hours,
          totalItems: items,
          // Days average per MCR entering SAP: total hours / working hours per day (e.g. 10/8 = 1.2)
          daysAverage: hours / WORK_HOURS_PER_DAY,
        };
      }).filter((row) => row.totalItems > 0 || row.totalHours > 0);

      this.leadTimeMcr = {
        onLoad: false,
        rows,
        summary: {
          totalItems: rows.reduce((sum, row) => sum + row.totalItems, 0),
          totalHours: rows.reduce((sum, row) => sum + row.totalHours, 0),
          totalDays: rows.reduce((sum, row) => sum + row.daysAverage, 0),
        },
      };
    },
    // Build MRP Composition matrix: rows = MRP element description (ND, V1 EX,
    // ...), columns = material types (ZM01, ZM03, ...). Values are item counts
    // aggregated across all months.
    mapMrpComposition(mrpByMonth) {
      const byMonth = mrpByMonth && typeof mrpByMonth === "object" ? mrpByMonth : {};
      const cellTotals = {};
      const descriptionTotals = {};
      const typeTotals = {};

      Object.values(byMonth).forEach((monthRows) => {
        if (!Array.isArray(monthRows)) return;

        monthRows.forEach((entry) => {
          if (!entry) return;
          const description = entry.description || "-";
          const materialType = entry.material_type || "-";
          const count = Number(entry.count) || 0;

          if (count <= 0) return;

          const cellKey = `${description}|${materialType}`;
          cellTotals[cellKey] = (cellTotals[cellKey] || 0) + count;
          descriptionTotals[description] = (descriptionTotals[description] || 0) + count;
          typeTotals[materialType] = (typeTotals[materialType] || 0) + count;
        });
      });

      // MRP element rows sorted by total item (desc) so the table is easier to scan
      const descriptionKeys = Object.keys(descriptionTotals).sort((a, b) => descriptionTotals[b] - descriptionTotals[a]);
      // Material type columns sorted by total item (desc)
      const typeKeys = Object.keys(typeTotals).sort((a, b) => typeTotals[b] - typeTotals[a]);

      this.mrpComposition = {
        onLoad: false,
        matrix: {
          types: typeKeys.map((type) => ({ key: type, label: type })),
          rows: descriptionKeys.map((description) => {
            const cells = {};
            typeKeys.forEach((type) => {
              cells[type] = cellTotals[`${description}|${type}`] || 0;
            });
            return { description, label: description, cells };
          }),
        },
      };
    },
    // Build Material Status matrix: rows = STATUS (Z1, Z2, ...), columns =
    // material types (ZFGD, ZSPR, ...). Client + plant levels are combined
    // because a material counts once per status regardless of level.
    mapMaterialStatus(statusByMonth) {
      const byMonth = statusByMonth && typeof statusByMonth === "object" ? statusByMonth : {};
      const cellTotals = {};
      const statusTotals = {};
      const typeTotals = {};

      Object.values(byMonth).forEach((monthData) => {
        if (!monthData || typeof monthData !== "object") return;

        ["client", "plant"].forEach((level) => {
          if (!Array.isArray(monthData[level])) return;

          monthData[level].forEach((entry) => {
            if (!entry) return;
            // Prefer explicit status field; fall back to the level reason
            // code (block_reason / plant_sp) which carries the Zx status.
            const status = entry.status || entry.block_reason || entry.plant_sp || "-";
            const materialType = entry.material_type || "-";
            const count = Number(entry.count) || 0;

            if (count <= 0) return;

            const cellKey = `${status}|${materialType}`;
            cellTotals[cellKey] = (cellTotals[cellKey] || 0) + count;
            statusTotals[status] = (statusTotals[status] || 0) + count;
            typeTotals[materialType] = (typeTotals[materialType] || 0) + count;
          });
        });
      });

      // STATUS rows follow the canonical order, unknown ones appended
      const statusKeys = Object.keys(statusTotals).sort((a, b) => {
        const idxA = MATERIAL_STATUS_ORDER.indexOf(a);
        const idxB = MATERIAL_STATUS_ORDER.indexOf(b);
        if (idxA !== -1 && idxB !== -1) return idxA - idxB;
        if (idxA !== -1) return -1;
        if (idxB !== -1) return 1;
        return a.localeCompare(b);
      });
      // Material type columns sorted by total item (desc)
      const typeKeys = Object.keys(typeTotals).sort((a, b) => typeTotals[b] - typeTotals[a]);

      this.materialStatus = {
        onLoad: false,
        matrix: {
          types: typeKeys.map((type) => ({ key: type, label: type })),
          rows: statusKeys.map((status) => {
            const cells = {};
            typeKeys.forEach((type) => {
              cells[type] = cellTotals[`${status}|${type}`] || 0;
            });
            return { status, label: status, cells };
          }),
        },
      };
    },
    // last_update dari API berformat "2026-09-21 16:46:38"; spasi diganti "T"
    // karena Safari/iOS menolak format bertanda spasi.
    formatLastUpdate(value) {
      const date = value ? new Date(String(value).replace(" ", "T")) : null;
      if (!date || Number.isNaN(date.getTime())) return "-";
      return date.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
    },
    formatNumber(value, decimals = 2) {
      const num = Number(value);
      if (!Number.isFinite(num)) return "-";
      return num.toFixed(decimals);
    },
    mapMcrs(mcrByMonth) {
      const keys = [
        { key: "processing", label: "Processing" },
        { key: "rejected", label: "Rejected" },
        { key: "stored_in_sap", label: "Stored in SAP" },
        { key: "closed", label: "Closed" },
        { key: "canceled", label: "Canceled" },
        { key: "duplicated", label: "Duplicated" },
      ];

      const totals = {};
      keys.forEach(({ key }) => {
        totals[key] = { material_creation: 0, material_revision: 0 };
      });

      if (mcrByMonth) {
        Object.values(mcrByMonth).forEach((month) => {
          if (!month) return;
          keys.forEach(({ key }) => {
            const entry = month[key];
            if (entry) {
              totals[key].material_creation += entry.material_creation || 0;
              totals[key].material_revision += entry.material_revision || 0;
            }
          });
        });
      }

      this.mcrTable.data = keys.map(({ key, label }) => ({
        deskripsi: label,
        creation: totals[key].material_creation,
        revision: totals[key].material_revision,
      }));
      this.mcrTable.onLoad = false;
    },
  },
};
</script>

<style scoped>
.font-mono {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-xs {
  font-size: 0.75rem;
}
</style>